import Lozenge, { ThemeAppearance } from '@atlaskit/lozenge';
import React from 'react';

const appearances: ThemeAppearance[] = ['default', 'removed', 'moved', 'new'];

const CapabilityTier: React.FC<{ tier: number }> = ({ tier }) => (
  <Lozenge appearance={appearances[tier]}>C{tier}</Lozenge>
);

export default CapabilityTier;
